import React, { useRef } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/dist/DrawSVGPlugin";
import { Box } from "@chakra-ui/react";
import { registerGsapPlugins, useTimelinePlayback } from "lib/gsap";
import { ScreenTwoSvg } from "./screen-2-svg";

registerGsapPlugins(ScrollTrigger, DrawSVGPlugin);

export function ScreenTwoAnimation({ isActive }: { isActive: boolean }) {
  const ref = useRef<HTMLDivElement>(null);
  const timeline = useRef<gsap.core.Timeline>();

  useTimelinePlayback(timeline, isActive);

  useGSAP(
    () => {
      const animationConfig = {
        defaults: {
          duration: 1.15,
          ease: "power1.inOut",
          drawSVG: "100% 100%",
        },
        scrollTrigger: {
          trigger: "#aid-product-screen-2",
          onEnter: () => timeline.current?.restart(true),
          onLeave: () => timeline.current?.pause(),
          onEnterBack: () => timeline.current?.restart(true),
          onLeaveBack: () => timeline.current?.pause(),
        },
      };

      timeline.current = gsap
        .timeline(animationConfig)
        .from("#aid-holdout-path", {}, "<")
        .from("#aid-treatment-path", {}, "<");
    },
    { scope: ref },
  );

  return (
    <Box ref={ref} borderTopRadius="6px" overflow="hidden">
      <ScreenTwoSvg id="aid-product-screen-2" />
    </Box>
  );
}
